import { useContext, useEffect } from "react";
import { Drawer } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LayoutContext } from "../../context/LayoutContext";
import SidebarContent from "./SidebarContent";

export default function Sidebar() {
  const theme = useTheme();
  const { collapsed, setCollapsed, mobileOpen, setMobileOpen } =
    useContext(LayoutContext);

  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1279px)");
  const isDesktop = useMediaQuery("(min-width:1280px)");

  useEffect(() => {
    if (isTablet) setCollapsed(true);
    if (isDesktop) setCollapsed(false);
  }, [isTablet, isDesktop, setCollapsed]);

  const paperSx = {
    background: `linear-gradient(to bottom, ${theme.sidebar.bgStart}, ${theme.sidebar.bgEnd})`,
    color: "#fff",
    borderRight: "none",
    overflowX: "hidden",
    // Inner scroll container styling (white background, primary thumb)
    "& .sidebar-inner-scroll": {
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#fff",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.primary.main} #fff`,
    },
  };

  return (
    <>
      {!isMobile && (
        <Drawer
          variant="permanent"
          open
          sx={{
            "& .MuiDrawer-paper": {
              width: collapsed ? 80 : 280,
              transition: "all .25s ease",
              ...paperSx,
            },
          }}
        >
          <SidebarContent />
        </Drawer>
      )}

      {!isDesktop && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: 280,
              ...paperSx,
            },
          }}
        >
          <SidebarContent overlay />
        </Drawer>
      )}
    </>
  );
}
